import { getBookingDetailsPageLink } from 'lib/links';
import { useScrollTopOnMount } from 'lib/hooks';
import { useDetailsBooking } from 'lib/hooks/useDetailsBooking';
import * as track from 'lib/gaTracking/cancelBookingPageEvents';
import { Container } from 'roo-ui/components';
import LoadingBlock from 'components/LoadingBlock';
import CancellationPolicyAlert from 'components/CancellationPolicyAlert';
import { TwoColumnWithBookingSummary } from 'components/Layout';
import CancellationPageLayout from '../CancellationPageLayout';
import { useCancellationQuote } from '../CancellationQuoteProvider';
import PropertyCharges from '../PropertyCharges';
import ActionBar from '../ActionBar';
import RefundOptions from '../RefundOptions';
import RefundSummary from '../RefundSummary';
import PaymentSummary from 'components/PaymentSummary';
import { bookingToPaymentSummaryProps } from 'components/PaymentSummary/helpers';
import { InPathFlightBookingAlert } from 'components/InPathFlightBookingAlert';

const ReviewCancellation = () => {
  const { booking } = useDetailsBooking();
  const { cancellation, cancellationState } = useCancellationQuote();
  const detailsPageLink = getBookingDetailsPageLink(booking.id);
  useScrollTopOnMount();

  return (
    <CancellationPageLayout>
      <Container pt={12} pb={0}>
        <InPathFlightBookingAlert m={0} />
      </Container>
      <TwoColumnWithBookingSummary heading="Confirm your cancellation and review any fees & charges" showSummaryOnMobile>
        {cancellationState === 'QUOTING' || !cancellation ? (
          <LoadingBlock />
        ) : (
          <>
            <PaymentSummary {...bookingToPaymentSummaryProps(booking)} />
            <CancellationPolicyAlert booking={booking} mb={[5, 8]} />
            <PropertyCharges penalty={cancellation.refund!.penalty} />
            <RefundOptions />
            <RefundSummary />
            <ActionBar backLinkUrl={detailsPageLink} onClickBackLink={track.manageBookingReturnLinkBottomSelected} />
          </>
        )}
      </TwoColumnWithBookingSummary>
    </CancellationPageLayout>
  );
};

export default ReviewCancellation;
